
// src/layouts/PageLayout.js
import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Controls from '../components/Controls';

const PageLayout = ({
  children,
  showControls = false,
  sidebarProps,
  controlsProps,
}) => {
  const [showSidebarMobile, setShowSidebarMobile] = useState(false);

  useEffect(() => {
    setShowSidebarMobile(false);
  }, [controlsProps?.selectedCompany]);

  useEffect(() => {
    if (!showSidebarMobile) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [showSidebarMobile]);

  return (
    <main className="max-w-7xl mx-auto px-4 py-6 relative">
      <div className="flex flex-col gap-6 md:flex-row">
        {/* MAIN CONTENT */}
        <div className="flex-1 min-w-0 order-1 md:order-2">
          {showControls && (
            <div className="mb-6">
              <Controls {...controlsProps} />
            </div>
          )}

          {children}
        </div>

        {/* DESKTOP SIDEBAR */}
        <aside className="hidden md:block md:order-1">
          <Sidebar {...sidebarProps} />
        </aside>
      </div>

      {/* MOBILE: Floating button */}
      <button
        type="button"
        onClick={() => setShowSidebarMobile(true)}
        className="md:hidden fixed bottom-4 right-4 z-[10000] rounded-full bg-brand-600 text-white px-4 py-3 shadow-lg active:scale-95 transition-transform text-sm font-medium"
        aria-label="Open company details"
      >
        Company
      </button>

      {/* MOBILE: Backdrop */}
      <div
        className={`md:hidden fixed inset-0 z-[9998] bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${
          showSidebarMobile ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setShowSidebarMobile(false)}
        aria-hidden={!showSidebarMobile}
      />

      {/* MOBILE: Off-canvas drawer */}
      <aside
        className={`md:hidden fixed top-0 right-0 z-[9999] h-full w-[85%] max-w-sm bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          showSidebarMobile ? 'translate-x-0' : 'translate-x-full'
        }`}
        role="dialog"
        aria-modal="true"
        aria-label="Company details"
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h2 className="text-sm font-semibold text-gray-800">
            Company details
          </h2>
          <button
            type="button"
            onClick={() => setShowSidebarMobile(false)}
            className="text-gray-400 hover:text-gray-700 transition-colors"
            aria-label="Close company details"
          >
            ✕
          </button>
        </div>

        <div className="p-4 overflow-y-auto h-full">
          <Sidebar {...sidebarProps} />
        </div>
      </aside>
    </main>
  );
};

export default PageLayout;



